import React from "react";
import ReactTooltip from "react-tooltip";
import logger from "../../../utils/LoggerFrontend";
import { CornerDownRightIcon, InfoIcon } from "../../../Components/Icons";
import {
  ArrowPointer,
  Barometer,
  FlexDiv,
  JobCategorySelector,
  JobSection,
  Tipp,
  TippInfo,
  TippSection,
  TippWrapper
} from "./CreateTipp.styled";
import { useTranslation } from "react-i18next";
const {
  getL1JobCategory,
  getL2JobCategory,
  getL1JobCategories,
  getJobSubcategories,
  getJobCategoryName
} = require("../../../utils/Helpers");

const getCitySize = (city_size, t) => {
  if (city_size === "small") {
    return t("Small");
  } else if (city_size === "large") {
    return t("Large");
  }
  return t("Medium");
};

export const CreateTipp = ({
  left,
  title,
  onChangeJobCategory,
  jobCategoryId,
  minClicks,
  city_size,
  locations,
  campaignDuration,
  // Props for assistant budget check
  tippWidth
}) => {
  const { t } = useTranslation();

  const onChangeJobCategoryHandler = (e) => {
    const newJobCategoryId = e.target.value;
    const l1JobCategoryId = getL1JobCategory(newJobCategoryId);
    const jobCategoryName = getJobCategoryName(l1JobCategoryId);

    logger.log("CampaignCreateTipp:onChangeJobCategoryHandler:jobCat", "called", {
      newJobCategoryId,
      l1JobCategoryId,
      jobCategoryName
    });

    const newJobCategoryUpdates = {
      kldb_l2_category: jobCategoryName,
      kldb_l2_category_ml4: jobCategoryName,
      tb_category: jobCategoryName,
      tb_v2_category: jobCategoryName,
      tb_v2_category_ml4: jobCategoryName,
      confidence: 0.999999
    };

    onChangeJobCategory(newJobCategoryId, newJobCategoryUpdates);
  };

  const renderJobCategory = (jobCategoryId) => {
    logger.debug("CampaignCreateTipp:renderJobCategory:jobCat", "called", { jobCategoryId });
    if (!jobCategoryId) {
      return "-";
    }

    const jobCategoryIdL1 = getL1JobCategory(jobCategoryId);
    const jobCategoriesL1 = getL1JobCategories();

    return (
      <select value={jobCategoryIdL1} onChange={onChangeJobCategoryHandler}>
        {jobCategoriesL1.map((item) => {
          return (
            <option key={item} value={item}>
              {getJobCategoryName(item)}
            </option>
          );
        })}
      </select>
    );
  };

  const renderDetailedJobCategory = (jobCategoryId) => {
    logger.debug("CampaignCreateTipp:renderDetailedJobCategory:jobCat", "called", {
      jobCategoryId
    });
    if (!jobCategoryId) {
      return;
    }

    const jobCategoryIdL1 = getL1JobCategory(jobCategoryId);
    const jobCategoryIdL2 = getL2JobCategory(jobCategoryId);

    logger.debug("CampaignCreateTipp:renderDetailedJobCategory:jobCat", "after", {
      jobCategoryIdL1,
      jobCategoryIdL2
    });

    const jobCategorySubCategoryIds = getJobSubcategories(jobCategoryIdL1);

    if (jobCategorySubCategoryIds.length > 0) {
      return (
        <JobCategorySelector>
          <CornerDownRightIcon size="16" />
          <select value={jobCategoryIdL2} onChange={onChangeJobCategoryHandler}>
            {jobCategorySubCategoryIds.map((subCategoryId) => {
              return (
                <option key={subCategoryId} value={subCategoryId}>
                  {getJobCategoryName(subCategoryId)}
                </option>
              );
            })}
          </select>
        </JobCategorySelector>
      );
    }
  };

  logger.debug("campaigncreatetipp:render", "called", { locations });
  const audienceSize = getCitySize(city_size, t);

  const locationsString = locations
    .map((locationObject) => `${locationObject?.location} +${locationObject?.radius}km`)
    .join(", ");

  return (
    <TippWrapper width={tippWidth}>
      <Tipp>
        <FlexDiv>
          <Barometer>
            <img src="/images/barometer.png" alt="barometer icon" />
          </Barometer>
          <TippInfo>
            <h2>{title}</h2>
            <p>
              {t(
                "based on factors such as historical campaign data, the budget entered and market data about the target audience."
              )}
            </p>
            <TippSection>
              <span>{t("Guaranteed minimum qualified clicks")}: </span>
              {`${minClicks} - ${parseInt(minClicks, 10) * 6}`}
              <InfoIcon
                size="10px"
                dataTip={t("These are the guaranteed minimum clicks for this campaign")}
              />
              {` ${t("Clicks with Fair Click Policy")}. `}
              <InfoIcon
                size="10px"
                dataTip={t(
                  "There is no limit to the number of clicks. As long as there is still campaign budget available, the campaign will continue."
                )}
              />
            </TippSection>
            <JobSection>
              {t("Job category")}: <br />
              {renderJobCategory(jobCategoryId)}
              <br />
              {renderDetailedJobCategory(jobCategoryId)}
            </JobSection>
            <TippSection>
              <span>{t("location-dependent target group")}:</span>
              <InfoIcon
                size="10px"
                dataTip={`${t("Reachable people based on")} ${
                  locations?.length > 1 ? t("Locations") : t("Location")
                }: ${locationsString}. ${t(
                  "Target group increases by specifying additional locations."
                )}`}
              />{" "}
              {audienceSize}
            </TippSection>

            <TippSection margins="0 0 15px">
              <span>{t("Campaign duration")}:</span>
              <br />
              {t("{{duration}} days", { duration: campaignDuration })}
            </TippSection>
          </TippInfo>
        </FlexDiv>
      </Tipp>
      <ReactTooltip className="campaign_create__tooltip" />
      <ArrowPointer left={left} />
    </TippWrapper>
  );
};
